module.exports = __webpack_public_path__ + "static/media/Filled-down-arrow.d634e5f9.svg";